import React, { createContext, useContext, useEffect, useState } from 'react'
import { WorkItemTask } from '../../types/Work/WorkItemTask'
import { WorkItem } from '../../types/Work/WorkItem'
import { RequestBacklog } from '../../types/Work/Request'
interface QCContextType {
	request: RequestBacklog | undefined
	setRequest: React.Dispatch<React.SetStateAction<RequestBacklog | undefined>>
    hierarchyPath: string | undefined
	task: WorkItemTask | undefined
	setTask: React.Dispatch<React.SetStateAction<WorkItemTask | undefined>>
	lastLayerWorkItem: WorkItem | undefined
}

const QCContext = createContext<QCContextType | null>(null)

const useQCContext = (): QCContextType => {
	const QCContextState = useContext(QCContext)
	if (QCContextState === null) {
		throw new Error(
			'QCContext not found. Try wrapping a parent component with <QCContext.Provider>.',
		)
	}
	return QCContextState
}

type QCProviderProps = {
	children?: React.ReactNode
	hierarchy: WorkItem
}

const QCProvider = ({ children, hierarchy }: QCProviderProps) => {
	const [request, setRequest] = useState<RequestBacklog>()
	const [task, setTask] = useState<WorkItemTask>()
	const [lastLayerWorkItem, setLastLayerWorkItem] = useState<WorkItem>()
	const [hierarchyPath, setHierarchyPath] = useState<string>()
	useEffect(() => {
        setHierarchyPath(generatePathAndSetTask(hierarchy))

    }, [])

	function generatePathAndSetTask(hierarchy: WorkItem) {
		const pathParts: string[] = []
		let current: WorkItem | null = hierarchy

		while (current) {
			pathParts.push(current.name)
			if(current.childrenWorkItems && current.childrenWorkItems.length > 0){
				current = current.childrenWorkItems[0]
			}else{
				setTask(current.tasks[0])
				setLastLayerWorkItem(current)
				current = null
			}
		}

		return pathParts.join(' > ')
	}

	return <QCContext.Provider value={{ request, setRequest, hierarchyPath, setTask, task, lastLayerWorkItem }}>{children}</QCContext.Provider>
}

export { useQCContext, QCProvider }
